import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProdutoPage from "../pages/produto/page";
import GeomembranaCategoryPage from "../pages/maquinas-de-solda-de-geomembrana/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/produto/:slug",
    element: <ProdutoPage />,
  },
  {
    path: "/maquinas-de-solda-de-geomembrana",
    element: <GeomembranaCategoryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
